import Text from "../../../Components/Text/Text";
import HeroImage from "../../../assets/images/integration-hero-image.png";
import { ReactComponent as RightTriangleSvg } from "../../../assets/svgs/right-triangle.svg";

export default function IntroductionSection() {
  return (
    <section
      className={`w-full h-screen bg-cover bg-left sm:bg-bottom bg-no-repeat bg-[url('./assets/images/mobile-application-hero-bg.png')]`}
    >
      <div className="container mx-auto h-full px-4 grid place-items-center sm:grid-cols-2 animate-fade-in-left">
        <div>
          <Text type="h1" size="xl" className="font-bold">
            Software Integration & API Development
          </Text>

          <Text
            type="h2"
            size="lg"
            className="font-semibold max-w-lg xl:max-w-3xl mt-8"
          >
            Connect Business Flows and Centralise your Data Between Systems
          </Text>

          <Text type="p" className="my-10 max-w-lg xl:max-w-3xl">
            Transform Your Business With An API Economy. Expose your digital
            services to keep up growth and overtake competition. Innovate your
            digital transformation with Agile Labs.
          </Text>
        </div>
        <div>
          <img src={HeroImage} alt="application development" />
        </div>
      </div>

      <RightTriangleSvg className="transition-all absolute bottom-0 fill-[#F4F4F4] animate-raise-up w-full" />
    </section>
  );
}
